import { z } from 'zod';
import { ApplicationSchema } from './application';
import { IsoTimestampSchema, UuidSchema } from './common';
import { MessageTypeSchema } from './messageType';

export const LogSchema = z.object({
  id: UuidSchema,
  applicationId: UuidSchema,
  messageTypeId: UuidSchema,
  timestamp: IsoTimestampSchema,
  message: z.string(),
  metadata: z.record(z.unknown()),
  createdAt: IsoTimestampSchema,
});

export const LogWithRelationsSchema = LogSchema.extend({
  application: ApplicationSchema.pick({
    id: true,
    name: true,
    product: true,
    company: true,
    instance: true,
  }),
  messageType: MessageTypeSchema.pick({ id: true, name: true, color: true }),
});

const MetadataFilterSchema = z
  .string()
  .regex(
    /^[^:]+:(eq|ne|gt|lt|contains):.+$/,
    'expected "key:op:value" with op in eq|ne|gt|lt|contains',
  )
  .optional();

export const ListLogsQuerySchema = z.object({
  applicationId: UuidSchema.optional(),
  messageTypeIds: z
    .string()
    .optional()
    .transform((v) => (v ? v.split(',').filter(Boolean) : undefined))
    .pipe(z.array(UuidSchema).optional()),
  search: z.string().min(1).max(200).optional(),
  from: IsoTimestampSchema.optional(),
  to: IsoTimestampSchema.optional(),
  metadata: MetadataFilterSchema,
  limit: z
    .string()
    .optional()
    .default('100')
    .transform((v) => Number.parseInt(v, 10))
    .pipe(z.number().int().min(1).max(500)),
  cursor: z.string().optional(),
});

export const ListLogsResponseSchema = z.object({
  items: z.array(LogWithRelationsSchema),
  nextCursor: z.string().nullable(),
});

export type Log = z.infer<typeof LogSchema>;
export type LogWithRelations = z.infer<typeof LogWithRelationsSchema>;
export type ListLogsQuery = z.infer<typeof ListLogsQuerySchema>;
export type ListLogsResponse = z.infer<typeof ListLogsResponseSchema>;
